import { render, staticRenderFns } from "./MHeader.vue?vue&type=template&id=1634b382&scoped=true"
import script from "./MHeader.vue?vue&type=script&lang=ts"
export * from "./MHeader.vue?vue&type=script&lang=ts"
import style0 from "./MHeader.vue?vue&type=style&index=0&id=1634b382&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1634b382",
  null
  
)

export default component.exports